var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, OnInit } from '@angular/core';
import { SelectableNavigationItem } from '../../../model/selectable-navigation-item';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { KeyDirections } from '../../../shared/key-directions.enum';
var PlayTrailerButtonComponent = /** @class */ (function (_super) {
    __extends(PlayTrailerButtonComponent, _super);
    function PlayTrailerButtonComponent(navigationService) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        _this.emitOnEnterPressed = new EventEmitter();
        _this.emitOnBack = new EventEmitter();
        _this.playingTrailer = false;
        return _this;
    }
    PlayTrailerButtonComponent.prototype.ngOnInit = function () {
        this.navigationService.registerNavigation(this, this.ownerComponent);
    };
    PlayTrailerButtonComponent.prototype.onEnter = function () {
        this.emitOnEnterPressed.emit();
    };
    PlayTrailerButtonComponent.prototype.onBack = function () {
        this.emitOnBack.emit({
            value: true
        });
    };
    PlayTrailerButtonComponent.prototype.canNavigateToDirection = function (keyCode) {
        if (this.playingTrailer) {
            return keyCode === KeyDirections.ESCAPE;
        }
        return true;
    };
    Object.defineProperty(PlayTrailerButtonComponent.prototype, "activeClass", {
        get: function () {
            return this.active;
        },
        enumerable: true,
        configurable: true
    });
    return PlayTrailerButtonComponent;
}(SelectableNavigationItem));
export { PlayTrailerButtonComponent };
